import React,{Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import {KeyboardArrowRight,FolderOpen,AvTimer,AccessTime,PermIdentity} from '@material-ui/icons/'

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    marginBottom:theme.spacing.unit * 3,
    textAlign:'left',
  }),
  p:{
      padding:0,
      textIndent:28,
      lineHeight:'40px'
  },
  icon:{
    position:'relative',
    top:5,
    width:20,
    height:20
  },
  iconBig:{
    position:'relative',
    top:10,
    height:40,
    width:40,
    color:'#3f51b5'
  },
  time:{
    fontSize:10,
    marginLeft:50
  }
});

class ProjectCard extends  Component{
  render(){
    const { classes ,project} = this.props;
    return (
      <div>
        <Paper className={classes.root} elevation={4}>
          <Typography variant="headline" component="h3"><FolderOpen className={classes.iconBig}/>
          {project.projectName}
          </Typography>
          <Typography variant="headline" component="h1">
          <span className={classes.time}><AvTimer className={classes.icon} />{project.startTime}</span>
          <span className={classes.time}><AccessTime className={classes.icon} />{project.endTime}</span>
          </Typography>
          {project.projectDetails.map((item,index)=><Typography component="p" key={index.toString()} className={classes.p}>
         <KeyboardArrowRight className={classes.icon}/>{item}</Typography>)}
         <Typography  component="p" className={classes.p}><PermIdentity className={classes.icon} />项目角色：
          {project.role}
          </Typography>
        </Paper>
      </div>
  );
}
}

ProjectCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectCard);


// WEBPACK FOOTER //
// ./src/projectIntroduce/projectcard.js